import { render } from "./GlobalErrorComponent.vue?vue&type=template&id=0a124d88"
import script from "./GlobalErrorComponent.vue?vue&type=script&lang=js"
export * from "./GlobalErrorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__